"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    id: "uuid-2f0d3432-d4cf-40df-84fe-5bf1a479e8bb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420.39 420.39",
    width: "100%",
    height: "100%",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M387.14,179.17c11.61-6.7,23.29,3.66,23.29,3.66l3.46-2-18.94-39.04c-2.42-4.98-6.85-8.67-12.16-10.21-20.9-6.07-46.92-18.46-34.87-36.71,6.7-11.61,22-8.48,22-8.48l2-3.46-35.93-24.34c-4.58-3.11-10.27-4.09-15.64-2.76-21.14,5.2-49.87,7.47-48.56-14.36,0-13.41,14.82-18.34,14.82-18.34v-4l-43.28-3.12c-5.52-.4-10.93,1.6-14.93,5.43-15.71,15.07-39.45,31.41-49.23,11.84-6.7-11.61,3.66-23.29,3.66-23.29l-2-3.46-39.04,18.94c-4.98,2.42-8.67,6.85-10.21,12.16-6.07,20.9-18.46,46.92-36.71,34.87-11.61-6.7-8.48-22-8.48-22l-3.46-2-24.34,35.92c-3.11,4.58-4.09,10.27-2.76,15.64,5.2,21.14,7.47,49.87-14.36,48.56-13.41,0-18.34-14.82-18.34-14.82h-4l-3.12,43.28c-.4,5.52,1.6,10.93,5.43,14.93,15.07,15.71,31.41,39.45,11.84,49.23-11.61,6.7-23.29-3.66-23.29-3.66l-3.46,2,18.94,39.04c2.42,4.98,6.85,8.67,12.16,10.21,20.9,6.07,46.92,18.46,34.87,36.71-6.7,11.61-22,8.48-22,8.48l-2,3.46,35.92,24.34c4.58,3.11,10.27,4.09,15.64,2.76,21.14-5.2,49.87-7.47,48.56,14.36,0,13.41-14.82,18.34-14.82,18.34v4l43.28,3.12c5.52,.4,10.93-1.6,14.93-5.43,15.71-15.07,39.45-31.41,49.23-11.84,6.7,11.61-3.66,23.29-3.66,23.29l2,3.46,39.04-18.94c4.98-2.42,8.67-6.85,10.21-12.16,6.07-20.9,18.46-46.92,36.71-34.87,11.61,6.7,8.48,22,8.48,22l3.46,2,24.34-35.92c3.11-4.58,4.08-10.27,2.76-15.64-5.2-21.14-7.47-49.87,14.36-48.56,13.41,0,18.34,14.82,18.34,14.82h4l3.12-43.28c.4-5.52-1.6-10.93-5.43-14.93-15.07-15.71-31.41-39.45-11.84-49.23Zm-176.94,63.23c-17.78,0-32.2-14.42-32.2-32.2s14.42-32.2,32.2-32.2,32.2,14.42,32.2,32.2-14.42,32.2-32.2,32.2Z",
      fill: "none",
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeWidth: "13px"
    })
  });
};

exports.default = Icon;